module.exports = __webpack_public_path__ + "img/icon-won.7043d86b.svg";